<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="供应商" v-if="findChildren(19)!==-1" name="supplier" style="height: 100%;">
				<supplier-index />
			</el-tab-pane>
			<el-tab-pane label="积分" v-if="findChildren(139)!==-1" name="supplierscore" style="height: 100%;">
				<supplierscore-index />
			</el-tab-pane>		
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import supplierIndex from './supplier/index.vue'
	import supplierscoreIndex from './supplierscore/index.vue'
	export default {
		props: {

		},

		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: [],
				showCancel:false
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if (this.departmentChildren.length != 0) {
				this.activeName = this.departmentChildren[0].controller
				//this.activeName = 'purchasestockbill'
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {

			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			supplierIndex,
			supplierscoreIndex

		}
	}
</script>